<template>

  <div>
    <task-add
        :is-add-sidebar-active.sync="isAddSidebarActive"
        @refetch-data="refetchData"
    />

<!--    &lt;!&ndash; Filters &ndash;&gt;-->
<!--    <pengajuan-filter-->
<!--        :tipe-options="tipeOptions"-->
<!--        :tipe-filter.sync="tipeFilter"-->
<!--        :status-options="statusOptions"-->
<!--        :status-filter.sync="statusFilter"-->
<!--    />-->


    <!-- Table Container Card -->
    <b-card
        no-body
        class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Tampilkan</label>
            <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>data</label>
          </b-col>

          <!-- Search -->
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
              />
              <b-button
                  variant="primary"
                  @click="isAddSidebarActive = true"
              >
                <span class="text-nowrap">Tambah Task</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetch"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Tidak ada data"
          :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(status)="data">
          <b-badge
              pill
              :variant="`light-${resolveStatusVariant(data.item.status)}`"
              class="text-capitalize"
          >
            {{ resolveStatusVariantLabel(data.item.status) }}
          </b-badge>
        </template>

<!--        <template #cell(foto)="data">-->
<!--          <b-media vertical-align="center">-->
<!--            <template #aside>-->
<!--              <img @click="handleShowLighbox(data.item.foto)" v-if="data.item.foto" :src="data.item.foto" alt="Image" width="50px" class="img-thumbnail">-->
<!--            </template>-->
<!--          </b-media>-->
<!--        </template>-->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
              />
            </template>

<!--            <b-dropdown-item @click.prevent="edit(data.item.id)">-->
<!--              <feather-icon icon="EditIcon"/>-->
<!--              <span class="align-middle ml-50">Edit</span>-->
<!--            </b-dropdown-item>-->

            <b-dropdown-item @click.prevent="destroy(data.item.id)">
              <feather-icon icon="TrashIcon"/>
              <span class="align-middle ml-50">Hapus</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Menampilkan {{ dataMeta.from }} sampai {{ dataMeta.to }} dari {{ dataMeta.of }} data</span>
          </b-col>
          <!-- Pagination -->
          <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <vue-easy-lightbox
        scrollDisabled
        moveDisabled
        :visible="lighboxVisible"
        :imgs="lighboxImage"
        @hide="handleHideLighbox"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {ref, onUnmounted} from '@vue/composition-api'
import taskAdd from './TaskAdd'
import taskList from "./TaskList"
import taskStoreModule from "./TaskStoreModule"
import {avatarText} from '@core/utils/filter'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  components: {
    taskAdd,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    VueEasyLightbox,
    vSelect,
  },
  data (){
    return {
      lighboxVisible: false,
      lighboxImage: null,
    }
  },
  props: {
    filter: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = 'app-task'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, taskStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })

    const isAddSidebarActive = ref(false)

    const {
      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,

      refetchData,
    } = taskList()

    return {
      // Sidebar
      isAddSidebarActive,

      fetch,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,
    }
  },
  methods: {
    destroy(id) {
      this.$swal({
        title: 'Apa anda yakin akan menghapus Task?',
        text: "Data task akan dihapus!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, hapus!',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-task/destroy', id)
              .then(() => {
                this.$swal({
                  icon: 'success',
                  title: 'Terhapus!',
                  text: 'Data task berhasil di hapus.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData()
              })
        }
      })
    },
    handleHideLighbox() {
      this.lighboxImage = null
      this.lighboxVisible = false
    },
    handleShowLighbox(image) {
      this.lighboxImage = image
      this.lighboxVisible = true
    }
  },
  created() {
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
